
<nav class="navbar sticky-top navbar-light"  style="height: 71px;">
    <a class="navbar-brand" routerLink="/">
        <img src="assets/images/logo.svg" height="60" width="180" alt="Logo">
    </a>
    <span class="ml-auto font-weight-bold d-none d-md-block text-lemken" style="font-size: 2rem;">
      {{ title }}
    </span>
    <span class="mr-auto font-weight-bold d-block d-sm-none d-md-none" style="font-size: 2rem;">
      &nbsp;
    </span>
    <span class="ml-auto">
    <fa-layers [fixedWidth]="true" *ngIf="haveConnectivityProblem" >
        <fa-icon icon="wifi" transform="shrink-6"></fa-icon>
        <fa-icon icon="ban" style="color: maroon;" ></fa-icon>
    </fa-layers>
    <fa-icon icon="exclamation-triangle" size="1x" [fixedWidth]="true" *ngIf="haveSyncError"></fa-icon>
    <fa-icon icon="sync" size="1x" [fixedWidth]="true" [spin]="true" *ngIf="isSyncing"></fa-icon>
    </span>
    <button class="navbar-toggler navbar-toggler-right rounded-circle text-lemken buttonMenu border-lemken"
            type="button" aria-label="Toggle menu"
            (click)="isNavbarCollapsed = !isNavbarCollapsed">
        <fa-icon icon="bars"></fa-icon>
    </button>

</nav>

<div class="menuPosition" *ngIf="!isNavbarCollapsed" id="menu">
    <div class="d-flex align-items-end flex-column mb-3">
        <div class="pt-2 pb-2 ">
            <button type="button" class="btn btn-secondary"
                    routerLink="/filter"
                    routerLinkActive="menuButtonActive"
                    aria-label="Go to the filter page"
                    (click)="isNavbarCollapsed = !isNavbarCollapsed"
            >
                <fa-icon icon="search" size="2x" [fixedWidth]="true"></fa-icon>
            </button>
        </div>

        <div class="pt-2 pb-2 ">
            <button type="button" class="btn btn-secondary"
                    routerLink="/comparison"
                    routerLinkActive="menuButtonActive"
                    aria-label="Go to the comparison"
                    (click)="isNavbarCollapsed = !isNavbarCollapsed"
            >
                <fa-icon icon="balance-scale" size="2x" [fixedWidth]="true"></fa-icon>
            </button>
        </div>
        <div class="pt-2 pb-2 ">
            <button type="button" class="btn btn-secondary"
                    routerLink="/setting"
                    routerLinkActive="menuButtonActive"
                    aria-label="Go to the setting part"
                    (click)="isNavbarCollapsed = !isNavbarCollapsed"
            >
                <fa-icon icon="cogs" size="2x" [fixedWidth]="true"></fa-icon>
            </button>
        </div>
        <div class="pt-2 pb-2 ">
            <button type="button" class="btn btn-secondary"
                    routerLink="/doc"
                    routerLinkActive="menuButtonActive"
                    aria-label="Go to the doc part"
                    (click)="isNavbarCollapsed = !isNavbarCollapsed"
            >
                <fa-icon icon="file" size="2x" [fixedWidth]="true"></fa-icon>
            </button>
        </div>
    </div>
</div>

<router-outlet></router-outlet>

<div class="overlayDiv" *ngIf="!isTableSyncOneTime && !isPageSetting">
    <div class="overlayCaption text-center text-white">
        <h1>{{ 'mainPage.waitData' | translate }}</h1>
        <fa-icon icon="spinner" size="4x" [fixedWidth]="true" [pulse]="true"></fa-icon>
    </div>
</div>
